export default __webpack_public_path__ + "static/media/brandballoon-five.7309a52f.png";